module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/pdp_paperRecycled-9fdd0b6eb8f88f0c457481ee3cc508c5.jpg";